import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Taskbar presentation. `labelled` shows the page name under each icon and is
 * the default; `compact` is the narrow icon-only rail, for people who would
 * rather trade the labels for screen width.
 */
export type NavMode = 'labelled' | 'compact';

interface NavModeState {
  mode: NavMode;
  setMode: (mode: NavMode) => void;
  toggle: () => void;
}

export const useNavModeStore = create<NavModeState>()(
  persist(
    (set) => ({
      mode: 'labelled',
      setMode: (mode) => set({ mode }),
      toggle: () =>
        set((state) => ({
          mode: state.mode === 'labelled' ? 'compact' : 'labelled',
        })),
    }),
    { name: 'nav-mode' },
  ),
);

export const NAV_RAIL_WIDTH: Record<NavMode, string> = {
  labelled: '76px',
  compact: '52px',
};
